import React from 'react';
import './Question.css'

const AnswerYes = () => {
    return <div>
        <p>
            Yes, correct, composing multiple pure functions creates 
            complex behaviour while maintaining referential transparency.
        </p> 
    </div>
}

const AnswerNo = () => {
    return <div>
        <p>
            Functional programming can reliably combine many small functions together.
        </p>
    </div>
}

const Answer = (props) => {
    if (props.answer === 'answerYes') {
        return <AnswerYes />
    } else if (props.answer === 'answerNo') {
        return <AnswerNo />
    } else {
        return <p>Please click an answer button above.</p>
    }
}

class QCompose extends React.Component {
    constructor(props) {
        super(props);
        this.state = {question: 'unanswered'};
    }
    render() {
        return <div className="Question">
            <p>
                Can small functions create big applications?
            </p>
            <br/>
            <div>
                <span className="Button Affirmative" 
                onClick={()=> this.setState({question: 'answerYes'})}
                > Yes </span>
                <span className="Button Negative"
                onClick={()=> this.setState({question: 'answerNo'})}                
                >No</span>
            </div>
            <br/>
            <Answer answer={this.state.question} />
        </div>
    }
}

export default QCompose;


// WEBPACK FOOTER //
// ./src/components/q_compose.js